import { reactive } from 'vue'

const body = document.querySelector('body')

export const constants = reactive({
    width: window.innerWidth,
    badgeDiscount: body.getAttribute('data-discount-badge'),
    badgeWolt: body.getAttribute('data-wolt-badge'),
    badgeOutOfStock: body.getAttribute('data-out-of-stock-badge'),
    currency: body.getAttribute('data-currency'),
    currencyShortcut: body.getAttribute('data-currency-shortcut'),
    locale: body.getAttribute('data-language'),
    defaultImage: body.getAttribute('data-default-image'),
    clientWidth: window.innerWidth,
})
